import Hectares from "./Hectares";
import Dropdown from "./Dropdown";
import ClassicInput from "./ClassicInput";
import StartWithWithoutGroup from "./StartWithWithoutGroup";
import BooleanInput from "./BooleanInput";
import RadioGroupInput from "./RadioGroupInput";
import TierTwoSWWGroup from "./TierTwoSWWGroup";
import TierTwoDropdown from "./TierTwoDropdown";
import TierTwoClassicInput from "./TierTwoClassicInput";
import TierTwoEmissions from "./TierTwoEmissions";
import TierTwoDynEmissions from "./TierTwoDynEmissions";
import CalendarInput from "./CalendarInput";
import CheckBoxesInputGroup from "./CheckBoxesInputGroup";
import CreatableSelect from "./CreatableSelect";
import TierTwoBooleanInput from "./TierTwoBooleanInput";
import TierTwoEmissionsByGas from "./TierTwoEmissionsByGas";
import CalendarYearSelect from "./CalendarYearSelect";
import TypeOfForestRadioGroup from "../../../pages/activityBuilder/modules/forestManagement/TypeOfForestRadioGroup";
import TierTwoInput from "./TierTwoInput";

import { FieldType } from "../../../types/modulesInterfaces";
import type {
	BooleanInputGroup,
	ClassicInputGroup,
	ClassicInputGroupTierTwo,
	DropdownInputGroup,
	DropdownInputGroupTierTwo,
	DynamicEmissionsTierTwo,
	EmissionsTierTwo,
	HectaresInputGroup,
	InputGroup,
	RadioInputGroup,
	StartWithWithoutGeneric,
	StartWithWithoutTierTwo,
	DatepickerInputGroup,
	CheckboxesInputGroup,
	CreateDropdownInputGroup,
	BooleanInputGroupTierTwo,
	CalendarYearSelectGroup,
	EmissionsByGasTierTwo,
	ForestRadioGroupInputGroup,
	InputT2Group,
} from "../../../types/modulesInterfaces";
import { usePermissions } from "../../../app/hooks";


const GenericInputGroup = ({ inputGroup, showCommentIcon }: { inputGroup: InputGroup, showCommentIcon: boolean }) => {
	const { isReadOnly } = usePermissions();

	switch (inputGroup.type) {
		case FieldType.HECTARES:
			return <Hectares {...(inputGroup as HectaresInputGroup)} />;
		case FieldType.SWW:
		case FieldType.SWW_BOOL:
		case FieldType.SWW_SELECT:
			return (
				<StartWithWithoutGroup {...(inputGroup as StartWithWithoutGeneric)} showCommentIcon={isReadOnly ? false : showCommentIcon} />
			);
		case FieldType.SELECT:
		case FieldType.SELECT_LUC:
			return <Dropdown {...(inputGroup as DropdownInputGroup)} />;
		case FieldType.CREATEABLE_SELECT:
			return <CreatableSelect {...(inputGroup as CreateDropdownInputGroup)} />;
		case FieldType.CLASSIC:
			return <ClassicInput {...(inputGroup as ClassicInputGroup)} />;
		case FieldType.BOOLEAN:
			return <BooleanInput {...(inputGroup as BooleanInputGroup)} />;
		case FieldType.DATEPICKER:
			return <CalendarInput {...(inputGroup as DatepickerInputGroup)} />;
		case FieldType.RADIO:
			return <RadioGroupInput {...(inputGroup as RadioInputGroup)} />;
		case FieldType.FOREST_RADIO_GROUP:
			return <TypeOfForestRadioGroup inputGroup={inputGroup as ForestRadioGroupInputGroup} disabled={isReadOnly} />;
		case FieldType.CHECKBOXES:
			return <CheckBoxesInputGroup {...(inputGroup as CheckboxesInputGroup)} />;
		case FieldType.CALENDAR_YEAR_SELECT:
			return <CalendarYearSelect {...(inputGroup as CalendarYearSelectGroup)} />;
		case FieldType.SWW_T2:
			return <TierTwoSWWGroup {...(inputGroup as StartWithWithoutTierTwo)} />;
		case FieldType.SELECT_T2:
			return <TierTwoDropdown {...(inputGroup as DropdownInputGroupTierTwo)} />;
		case FieldType.CLASSIC_T2:
			return (
				<TierTwoClassicInput {...(inputGroup as ClassicInputGroupTierTwo)} />
			);
		case FieldType.BOOLEAN_T2:
			return (
				<TierTwoBooleanInput {...(inputGroup as BooleanInputGroupTierTwo)} />
			);
		case FieldType.EMISSIONS_T2:
			return <TierTwoEmissions {...(inputGroup as EmissionsTierTwo)} />;
		case FieldType.EMISSIONS_BY_GAS_T2:
			return <TierTwoEmissionsByGas {...(inputGroup as EmissionsByGasTierTwo)} />;
		case FieldType.DYN_EMISSIONS_T2:
			return (
				<TierTwoDynEmissions {...(inputGroup as DynamicEmissionsTierTwo)} />
			);
		case FieldType.INPUT_T2:
			return <TierTwoInput {...(inputGroup as InputT2Group)} />;
		default:
			return <></>;
	}
};

export default GenericInputGroup;

GenericInputGroup.defaultProps = {
	showCommentIcon: true,
}